import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Input from "components/ui/Input";
import useFinancialYearStore from "store/financialYear";
import { useGenerateDayBookReport } from "http-hooks/daybook/useDaybook";
import { getDocumentViewerRoute } from "utils/documentUrlHelper";

const DayBook = () => {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState("");

  // Mutation for generating report
  const { mutateAsync: generateReport, isPending: isGenerating } = useGenerateDayBookReport();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const formData = {
      selectedDate,
    };

    const data = await generateReport(formData);

    if (data?.filePath) {
      const baseUrl = process.env.REACT_APP_MAIN_BASE_URL || "";
      const htmlUrl = `${baseUrl}${data.filePath}`;

      const route = getDocumentViewerRoute("daybook", {
        htmlUrl,
        pdfUrl: "",
        documentNumber: selectedDate,
        documentType: "Day Book",
      });

      navigate(route);
    }
  };

  const isFormValid = () => {
    return selectedDate !== "";
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-xl font-semibold text-gray-900">Day Book Report Generator</h1>
          <p className="mt-2 text-sm text-gray-700">
            Generate day book report for a specific date
          </p>
        </div>
      </div>

      <div className="mt-8">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl">
            <div className="px-4 py-6 sm:p-8">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {/* Date Input */}
                <div className="col-span-1 md:col-span-2 lg:col-span-1">
                  <Input
                    label="Date"
                    type="date"
                    name="selectedDate"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    now={true}
                    withinFY={true}
                    required
                  />
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
              <button
                type="submit"
                disabled={!isFormValid() || isGenerating}
                className={`rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${
                  isFormValid() && !isGenerating && "bg-indigo-600 hover:bg-indigo-500"
                } ${(!isFormValid() || isGenerating) && "bg-gray-400 cursor-not-allowed"}`}
              >
                {isGenerating ? "Generating..." : "Generate Report"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DayBook;

